module.exports = "https://dhstatic.bthome.com/prod/web/activity_h5/img/goods_1col.bf817e8befaaff24.png";